/**
 * useCommunityRitualRequests Hook
 * Fetches pending ritual organizer requests for a community
 */

import { useQuery } from "@tanstack/react-query"
import { getCommunityRitualRequests } from "../services/ritual.service"

interface UseCommunityRitualRequestsOptions {
  page?: number
  limit?: number
  search?: string
  enabled?: boolean
}

export function useCommunityRitualRequests(
  communityId: string,
  options?: UseCommunityRitualRequestsOptions,
) {
  return useQuery({
    queryKey: [
      "community-ritual-requests",
      communityId,
      options?.page,
      options?.limit,
      options?.search,
    ],
    queryFn: () =>
      getCommunityRitualRequests(communityId, {
        page: options?.page,
        limit: options?.limit,
        search: options?.search,
      }),
    enabled: options?.enabled ?? !!communityId,
    staleTime: 1000 * 60 * 5,
  })
}
